import { useEffect } from "react";

import SuccessIcon from "@icons/success-icon.svg";
import { TypographyH5 } from "@src/components/shared-ui-components/CustomTypography";

import Cookies from "js-cookie";
import { IconWrapper } from "./style";

const LoginSuccess = () => {
  useEffect(() => {
    const userData =
      document.cookie
        ?.split("; ")
        ?.find((cookie) => cookie.startsWith("user_data="))
        ?.split("=")?.[1] || "";
    const decodedUserData = decodeURIComponent(userData);
    // const formattedUserData = JSON.stringify(JSON.parse(decodedUserData));
    Cookies.set("userData", decodedUserData);
    Cookies.remove("user_data");

    setTimeout(() => {
      window.close();
    }, 1000);
  }, []);

  return (
    <IconWrapper>
      <img src={SuccessIcon} width={100} height={100} alt="" />
      <div style={{ marginTop: 8 }}>
        <TypographyH5>Login Success</TypographyH5>
      </div>
    </IconWrapper>
  );
};

export default LoginSuccess;
